import { CommonModule } from "@angular/common";
import { MaterialModule } from "./material.module";
import { NgModule } from "@angular/core";
import { ProgressSpinnerComponent } from "../shared/progressSpinner/progressSpinner.component";
import { RouterLink, RouterOutlet } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { OwlDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { WidgetLoaderComponent } from "./widget-loader/widget-loader.component";
import { LoaderComponent } from "./loader/loader.component";
import { DateFormatPipe } from "../shared/pipes/date-format.pipe";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FilterPipe } from "./pipes/filter.pipe";
import { hour12FlagPipe } from "./pipes/hour12-format.pipe";
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { ClickOutsideDirective } from "../_helpers/click-outside.directive";
import { RingsLoaderComponent } from "./rings-loader/rings-loader.component";
import { GroupByPipe } from "./pipes/group-by.pipe";
import { AutoSanitizeDirective } from "../_helpers/auto-sanitize.directive";
import { TabMainComponent } from "../components/new-dashboard-v2/tab-main/tab-main.component";
import { HierarchyNodeComponent } from "./hierarchy-node/hierarchy-node.component";
import { FlyoutContainerComponent } from "./flyout/flyout-container/flyout-container.component";
import { StepperContainerComponent } from "./stepper/stepper-container.component";
import { TranslateModule } from "@ngx-translate/core";
import { DynamicFormFieldComponent } from "./dynamic-form-field/dynamic-form-field.component";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { BarcodeComponent } from "../barcode/barcode.component";
import { OptionRowComponent } from "./option-row/option-row.component";
import { RichTextEditorComponent } from "./rich-text-editor/rich-text-editor.component";
import { NullDisplayPipe } from './pipes/null-display.pipe';
import { ObjectHasPermissionDirective } from "../_helpers/object-has-permission.directive";
import { EnumNamePipe } from './pipes/enum-name.pipe';
import { MapLookupPipe } from './pipes/map-lookup.pipe';
import { TrendIconPipe } from './pipes/trend-icon.pipe';
import { ChartAnnotationPopupComponent } from './chart/chart-annotation-popup/chart-annotation-popup.component';

@NgModule({
  declarations: [
    WidgetLoaderComponent,
    ProgressSpinnerComponent,
    RingsLoaderComponent,
    LoaderComponent,
    DateFormatPipe,
    FilterPipe,
    hour12FlagPipe,
    SafeHtmlPipe,
    GroupByPipe,
    ClickOutsideDirective,
    AutoSanitizeDirective,
    TabMainComponent,
    HierarchyNodeComponent,
    FlyoutContainerComponent,
    StepperContainerComponent,
    DynamicFormFieldComponent,
    BarcodeComponent,
    OptionRowComponent,
    NullDisplayPipe,
    ObjectHasPermissionDirective,
    EnumNamePipe,
    MapLookupPipe,
    ChartAnnotationPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterLink,
    NgxPaginationModule,
    OwlDateTimeModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    RouterOutlet,
    TranslateModule,
    NgxMatTimepickerModule,
    RichTextEditorComponent,
    TrendIconPipe
  ],
  exports: [
    MaterialModule,
    ProgressSpinnerComponent,
    RingsLoaderComponent,
    RouterLink,
    NgxPaginationModule,
    OwlDateTimeModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetLoaderComponent,
    LoaderComponent,
    DateFormatPipe,
    FilterPipe,
    DragDropModule,
    hour12FlagPipe,
    SafeHtmlPipe,
    GroupByPipe,
    NgxMatTimepickerModule,
    ClickOutsideDirective,
    AutoSanitizeDirective,
    TabMainComponent,
    HierarchyNodeComponent,
    FlyoutContainerComponent,
    StepperContainerComponent,
    DynamicFormFieldComponent,
    BarcodeComponent,
    OptionRowComponent,
    NullDisplayPipe,
    TranslateModule,
    RichTextEditorComponent,
    ObjectHasPermissionDirective,
    EnumNamePipe,
    MapLookupPipe,
    TrendIconPipe
  ],
})
export class SharedModule {}
